import React, { Component } from 'react';
import { connect } from 'react-redux';

import DateProperties from './Type/DateProperties';
import DisplayProperties from './Type/DisplayProperties';
import LongTextProperties from './Type/LongTextProperties';
import MedicationSearchProperties from './Type/MedicationSearchProperties';
import PainScaleProperties from './Type/PainScaleProperties';
import AttachmentProperties from './Type/AttachmentProperties';
import ShortTextProperties from './Type/ShortTextProperties';
import YesNoProperties from './Type/YesNoProperties';
import ChoiceProperties from './Type/ChoiceProperties';
import OpenChoiceProperties from './Type/OpenChoiceProperties';
import IntegerProperties from './Type/IntegerProperties';


const PropertyFactory = (question) => {
  if (!question) {
    return;
  }

  switch (question.type) {
    case 'date':
      return <DateProperties question={question} />;
    case 'choice':
      return <ChoiceProperties question={question} />;
    case 'display':
      return <DisplayProperties question={question} />;
    case 'text':
      return <LongTextProperties question={question} />;
    case 'medication-search':
      return <MedicationSearchProperties question={question} />;
    case 'open-choice':
      return <OpenChoiceProperties question={question} />;
    case 'pain-scale':
      return <PainScaleProperties question={question} />;
    case 'attachment':
      return <AttachmentProperties question={question} />;
    case 'string':
      return <ShortTextProperties question={question} />;
    case 'boolean':
      return <YesNoProperties question={question} />;
    case 'integer':
      return <IntegerProperties question={question} />
    default:
      return false;
  }
};

class Properties extends Component {
  render() {
    const question = this.props.question;

    return (
      <div className="row row-cols-1">
        <div className="col mb-2" style={{ borderBottom: '4px solid #1AB2E9' }}>
          <h5>Properties</h5>
        </div>

        <div className="col">
          {PropertyFactory(question)}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    question: state.questionLibrary.current
  }
}

export default connect(mapStateToProps)(Properties);